module.exports = __webpack_public_path__ + "media/assets/images/wallpapers/disenia_hq-68bfe4f56e05ce8dcd68c1d2226b563f.jpg";